import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

type Props = {
  date: Date;
  durationMinutes: number;
  slots: string[];
  /** In PREVIEW, changing date should jump back to calendar view */
  onBackToMonth: () => void;
};

const fmtDate = (d: Date) =>
  d.toLocaleString("en-GB", { day: "2-digit", month: "long", year: "numeric" });

const PreviewDaySlots: React.FC<Props> = ({
  date,
  durationMinutes,
  slots,
  onBackToMonth,
}) => {
  return (
    <div className="preview-cal">
      {/* header with chevrons that return to calendar */}
      <div className="flex items-center justify-between mb-1">
        <button type="button" onClick={onBackToMonth} aria-label="Back to month" className="p-2 text-[#7D7D7D]">
          <ChevronLeft className="w-5 h-5" />
        </button>

        <div className="text-[16px] font-extrabold text-[#2D2D2D]">
          {fmtDate(date)}
        </div>

        <button type="button" onClick={onBackToMonth} aria-label="Forward to month" className="p-2 text-[#7D7D7D]">
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      <div className="text-[12px] text-[#8A8A8A] text-center mb-4">
        Duration: {durationMinutes} Minutes
      </div>

      {/* slot pills (no rounded corners) */}
      <div className="space-y-3">
        {slots.map((t, i) => (
          <div key={`${t}-${i}`} className="h-[48px] border border-[#CFCFCF] bg-white grid place-items-center">
            <span className="text-[14px] font-extrabold text-[#2D2D2D]">{t}</span>
          </div>
        ))}
      </div>

      <style>{`
        .preview-cal [class*="rounded"]{ border-radius:0 !important; }
      `}</style>
    </div>
  );
};

export default PreviewDaySlots;
